import React, { useEffect } from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';
import { useTranslation } from 'react-i18next';
import ClaimRewardsResultAtom from '../../../recoil/cashout/ClaimRewardsResultAtom';
import DiamondBalanceAtom from '../../../recoil/cashout/DiamondBalanceAtom';
import useHttpRequest from '../../api/HttpRequest';
import Diamond from '../../icons/Diamond';

export default function DiamondBalance() {
  const httpRequest = useHttpRequest();

  // TODO -> add loading states
  const { t } = useTranslation(null, { useSuspense: false });
  const [diamondBalance, setDiamondBalance] = useRecoilState(DiamondBalanceAtom);
  const claimRewardsResult = useRecoilValue(ClaimRewardsResultAtom);

  const refreshDiamondBalance = () => {
    httpRequest.send('/economy/me/balance/DMD').then((result) => {
      const { balance } = result;
      setDiamondBalance(balance);
    }).catch((err) => {
      // eslint-disable-next-line no-console
      console.log('Error fetching a users diamond balance...', err);
      setDiamondBalance(null);
    });
  };

  useEffect(() => {
    refreshDiamondBalance();
    // eslint-disable-next-line
  }, [claimRewardsResult.updatedAt])

  return (
    <div className="member-diamonds">
      <h4>
        { t('diamonds_you_have')}
        {' '}
        <span className="member-diamonds-amount">
          { new Intl.NumberFormat().format(diamondBalance) }
        </span>
        {' '}
        { t('diamonds_diamonds')}
      </h4>

      <div className="member-diamonds">
        <div className="member-diamonds-logo">
          <Diamond />
        </div>
      </div>
    </div>
  );
}
